import { useContext, useEffect } from 'react'
import IntroSection from '../components/IntroSection'
import Button from '../components/Button'
import homeData from '../assets/data/homeData'
import { Link, useNavigate } from 'react-router-dom'
import { MdArrowForward } from "react-icons/md"
import { AiOutlineExclamationCircle } from "react-icons/ai";
import "../styles/button.css"
import { UserContext } from '../context/UserContext'

const mappedSections = homeData.map(section => (
  <IntroSection key={section.image} {...section} />
))

const Home = () => {
  const { loggedInUser } = useContext(UserContext)
  const navigate = useNavigate()

  useEffect(() => {
    if (!loggedInUser) return

    navigate("/questionnaire")
  }, [loggedInUser, navigate])

  return (
    <main className='container'>
      {mappedSections}
      <Link to="/Register" className='btn-link'>
        <Button variant="accent" text="Sign up" icon={<MdArrowForward />} />
      </Link>
      <p><AiOutlineExclamationCircle /> Artieve is not a substitute for a therapist.</p>
    </main>
  )
}

export default Home